import { Level } from '@susu/custom-made/utils/constants';
import { createContext } from 'react';

type NavigationContextType = {
  section: string | null;
  setSection: (section: string | null) => void;
  level: Level;
  setLevel: (level: Level) => void;
  isFinishButtonDisabled: boolean;
  setIsFinishButtonDisabled: (isFinishButtonDisabled: boolean) => void;
};

const defaultNavigationContext: NavigationContextType = {
  section: null,
  setSection: () => {},
  level: Level.Group,
  setLevel: () => {},
  isFinishButtonDisabled: false,
  setIsFinishButtonDisabled: () => {},
};

export const NavigationContext = createContext<NavigationContextType>(defaultNavigationContext);
